import { jsx as f, jsxs as $ } from "react/jsx-runtime";
import { useState as y, useRef as Q, useEffect as X, useCallback as r } from "react";
import { c as v } from "./index.CWkFp9WS.js";
import { O as q } from "./ODSDatePickerInputField.Dy4aEyJk.js";
import { u as B, D as G, a as H, b as J } from "./ODSDatePicker.utils.Dvmx0txe.js";
import { O as K } from "./ODSDatePickerFlyout.CoG54o6I.js";
import { u as W } from "./media-query.B9bznea_.js";
import { O as Z } from "./ODSColumn.B8Qu83P2.js";
import '../assets/ODSDatePicker.css';const V = ({
  size: c = "large",
  className: E,
  locale: F = "en",
  minDate: N = H,
  maxDate: A = J,
  defaultDate: O,
  inputProps: L,
  flyoutProps: t,
  format: k = "DD/MM/YYYY",
  disableFuture: M = !1,
  disablePast: b = !1,
  loading: g = !1,
  loadingSlot: z,
  disableCalendar: o = !1,
  flip: T = !0,
  dateValidator: i,
  onChange: n,
  onError: D,
  onMonthChange: l,
  onYearChange: m,
  onOk: Y,
  onCancel: w,
  ...C
}) => {
  const p = W("(max-width:361px)"), [a, S] = y(c), d = Q(null);
  X(() => {
    if (typeof window < "u" && p) {
      S("small");
      return;
    }
    S(c);
  }, [c, p]);
  const I = r(
    (e, s) => {
      l && l(e, s);
    },
    [l]
  ), U = r(
    (e, s) => {
      m && m(e, s);
    },
    [m]
  ), j = i ? r(
    (e) => i ? i(e) : !0,
    [i]
  ) : void 0, P = r(
    (e, s, u) => {
      n && n(e, s, u);
    },
    [n]
  ), h = r(
    (e, s, u) => {
      D && D(e, s, u);
    },
    [D]
  ), R = B({
    maxDate: A,
    minDate: N,
    locale: F,
    defaultDate: O,
    size: a,
    disableFuture: M,
    disablePast: b,
    dateValidator: j,
    onMonthChange: I,
    onYearChange: U,
    disableCalendar: o,
    containerRef: d,
    flip: T
  }), { label: x = "", ..._ } = L || {};
  return /* @__PURE__ */ f(G.Provider, { value: R, children: /* @__PURE__ */ $(
    Z,
    {
      className: v(
        "ODSDatePicker",
        `ODSDatePicker--size-${a}`,
        E
      ),
      ...C,
      as: "div",
      ref: d,
      children: [
        /* @__PURE__ */ f(
          q,
          {
            size: a,
            label: x,
            format: k,
            value: O,
            ..._,
            onChange: P,
            onError: h,
            disableCalendar: o
          }
        ),
        !o && /* @__PURE__ */ f(
          K,
          {
            "aria-label": x,
            ...t,
            className: v(
              "ODSDatePicker-OdsDatePickerFlyoutLarge",
              `ODSDatePicker-OdsDatePickerFlyoutLarge--size-${a}`,
              t == null ? void 0 : t.className
            ),
            size: a,
            format: k,
            onChange: P,
            onError: h,
            loading: g,
            loadingSlot: z,
            onOk: Y,
            onCancel: w
          }
        )
      ]
    }
  ) });
};
V.displayName = "ODSDatePicker";
export {
  V as O
};
//# sourceMappingURL=ODSDatePicker.C5_dkfPQ.js.map
